<template>
  <div class="spinner" :style="spinnerStyle"></div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#FF5500',
    },
    borderWidth: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    spinnerStyle() {
      return {
        '--spinner-size': `${this.size}px`,
        '--spinner-color': this.color,
        '--spinner-border-width': `${this.borderWidth}px`,
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
.spinner
  display inline-block
  width var(--spinner-size)
  height var(--spinner-size)
  border var(--spinner-border-width) solid rgba(0, 0, 0, 0.2)
  border-top-color var(--spinner-color)
  border-radius 50%
  animation spin 1s linear infinite

@keyframes spin
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)
</style>
